export default __webpack_public_path__ + "static/media/three.32dd97ff.png";